/* eslint-disable no-unused-vars */
export enum Http {
    POST = 'post',
    PUT = 'put',
    DELETE = 'delete',
    GET = 'get'
}
